export default __webpack_public_path__ + "static/1-c1203bc1a4ee26867467956e21693e72.jpg";